(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lily-product-actions"] && !Shopify.designMode) return;
  try {
    if (!window.LilyTheoryProductActionsBound) {
    window.LilyTheoryProductActionsBound = true;

    document.addEventListener('click', async (event) => {
      const giftButton = event.target.closest('[data-lily-gift-add]');

      if (giftButton) {
        const root = giftButton.closest('[data-lily-gift-option]');
        const status = root.querySelector('[data-lily-gift-status]');
        const variantId = Number(root.dataset.variantId);

        giftButton.disabled = true;
        status.textContent = 'Adding…';

        try {
          const base = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${base}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          });

          if (!response.ok) throw new Error('Unable to add gift packaging');

          status.textContent = 'Gift packaging added to your cart.';
          giftButton.textContent = 'Added to cart';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (error) {
          status.textContent = 'Please try again.';
          giftButton.disabled = false;
        }

        return;
      }

      const shareButton = event.target.closest('[data-lily-share-button]');

      if (shareButton) {
        const root = shareButton.closest('[data-lily-share]');
        const status = root.querySelector('[data-lily-share-status]');
        const shareData = {
          title: root.dataset.shareTitle,
          url: root.dataset.shareUrl,
        };

        try {
          if (navigator.share) {
            await navigator.share(shareData);
          } else if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(shareData.url);
            status.textContent = 'Link copied.';
          } else {
            window.prompt('Copy this link', shareData.url);
          }
        } catch (error) {
          if (error?.name !== 'AbortError') {
            status.textContent = 'Unable to share this link.';
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
